import styled from 'styled-components';

export const StyledRow = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-around;
  position: absolute;
  top: 500px;
`;
